import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e32e36b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "level-info" }
const _hoisted_2 = { class: "level-info__level" }

import { reactive, watch } from 'vue';
import Vue3autocounter from 'vue3-autocounter';
import { useUserStore } from '@/stores/userStore';
import BadgeComponent from '@/components/BadgeComponent.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'LevelInfo',
  setup(__props) {

const userStore = useUserStore();

const scores = reactive({
  current: userStore.score,
  previous: userStore.score
});

watch(
  () => userStore.score,
  (newScore, previousScore) => {
    scores.current = newScore;
    scores.previous = previousScore || 0;
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, " Level " + _toDisplayString(_unref(userStore).level), 1),
    _createVNode(BadgeComponent, null, {
      default: _withCtx(() => [
        _createVNode(_unref(Vue3autocounter), {
          startAmount: scores.previous,
          endAmount: scores.current,
          duration: 1.5,
          separator: "",
          autoinit: true,
          suffix: " Points"
        }, null, 8, ["startAmount", "endAmount"])
      ]),
      _: 1
    })
  ]))
}
}

})